/**
 * CLS-FI help-center config (labels + routes).
 */
export const HELP_LABELS = {
  sidebarTitle: 'Suositut aiheet',
  popular:      'Yleisimmät',
  // Reklamaatio hidden — uncomment label + route (and restore the App.js route) to bring it back.
  // claims:       'Reklamaatio',
  contact:      'Ota yhteyttä',
  sizeGuide:    'Kokotaulukko',
};

export const HELP_ROUTES = {
  faq:       '/clothing/cls-fi/faq',
  // claims:    '/clothing/cls-fi/claims',
  contact:   '/clothing/cls-fi/contact',
  sizeGuide: '/clothing/cls-fi/size-guide',
};
